export const SCHEDULES_LIST_STYLES = `
.schedules-list-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ── Schedules Section ── */
.schedules-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.schedules-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.schedules-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.schedules-loading,
.schedules-empty {
  padding: 16px;
  background: var(--bg-secondary, #f3f4f6);
  border-radius: 8px;
  color: var(--text-muted, #6b7280);
  font-size: 14px;
  text-align: center;
}

.schedules-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.schedule-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: var(--bg-secondary, #f9fafb);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  gap: 12px;
}

.schedule-info {
  flex: 1;
  min-width: 0;
}

.schedule-formatted {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary, #1f2937);
  word-break: break-word;
}

.schedule-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

/* ── Day Overrides Section ── */
.day-overrides-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.day-overrides-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.day-overrides-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.day-overrides-hint {
  font-size: 12px;
  color: var(--text-muted, #6b7280);
  margin-bottom: 8px;
}

.day-overrides-empty {
  padding: 16px;
  background: var(--bg-secondary, #f3f4f6);
  border-radius: 8px;
  color: var(--text-muted, #6b7280);
  font-size: 14px;
  text-align: center;
}

.day-overrides-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
}

.override-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: var(--bg-secondary, #f9fafb);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  gap: 8px;
}

.override-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.override-day {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.override-limit {
  font-size: 12px;
  color: var(--text-muted, #6b7280);
}

.override-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

/* ── Button Styles ── */
.btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, opacity 0.2s;
}

.btn-primary {
  background: var(--blue-500, #3b82f6);
  color: white;
}

.btn-primary:hover {
  background: var(--blue-600, #2563eb);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: var(--gray-200, #e5e7eb);
  color: var(--text-primary, #1f2937);
}

.btn-secondary:hover {
  background: var(--gray-300, #d1d5db);
}

.btn-danger {
  background: var(--red-500, #ef4444);
  color: white;
}

.btn-danger:hover {
  background: var(--red-600, #dc2626);
}

.btn-sm {
  padding: 4px 8px;
  font-size: 12px;
}
`;

export const SCHEDULES_EDITOR_STYLES = `
.schedule-editor-modal,
.day-override-editor-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: var(--bg-primary, white);
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.editor-header {
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  padding-bottom: 12px;
}

.editor-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.editor-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.editor-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.editor-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.editor-input {
  padding: 8px 10px;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: 4px;
  font-size: 14px;
  color: var(--text-primary, #1f2937);
  background: var(--bg-primary, white);
  transition: border-color 0.2s;
}

.editor-input:focus {
  outline: none;
  border-color: var(--blue-500, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.time-input {
  font-family: monospace;
}

/* Days grid */
.days-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
  gap: 8px;
}

.day-label {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  background: var(--bg-secondary, #f9fafb);
  transition: all 0.2s;
}

.day-label:hover {
  background: var(--bg-primary, white);
}

.day-checkbox {
  cursor: pointer;
}

.day-checkbox:checked + span {
  font-weight: 600;
  color: var(--blue-600, #2563eb);
}

.day-label:has(input:checked) {
  background: var(--blue-50, #eff6ff);
  border-color: var(--blue-300, #93c5fd);
}

/* Actions */
.editor-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary {
  background: var(--blue-500, #3b82f6);
  color: white;
}

.btn-primary:hover {
  background: var(--blue-600, #2563eb);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: var(--gray-200, #e5e7eb);
  color: var(--text-primary, #1f2937);
}

.btn-secondary:hover {
  background: var(--gray-300, #d1d5db);
}
`;
